import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=bfbb4942&"
import script from "./Tags.vue?vue&type=script&lang=ts&"
export * from "./Tags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports